import { useStack } from '@direct-frontend/components';
import { ErrorBlankSad } from '#shared/components/ErrorBlank';
import { useSetDocumentTitle } from '#shared/lib/dom';

export const NotFound = () => {
    useSetDocumentTitle('Страница не найдена');

    const cls = useStack({
        alignItems: 'center',
        justifyContent: 'center',
    });

    return (
        <div className={cls} style={{ height: '100%' }}>
            <ErrorBlankSad title="Страница не найдена" subtitle="Проверьте адрес текущей страницы" />
        </div>
    );
};
